export const Types = {
   DOUBT_MODAL: "DOUBT_MODAL",
   PRODUCT_MODAL: "PRODUCT_MODAL",
   TIMER_MODAL: "TIMER_MODAL",
   ADDRESS_MODAL: "ADDRESS_MODAL",
   SEARCH_MODAL: "SEARCH_MODAL",
}
